"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var ArrowDropLeft4_exports = {};
__export(ArrowDropLeft4_exports, {
  default: () => ArrowDropLeft4_default
});
module.exports = __toCommonJS(ArrowDropLeft4_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.7539 4.78125L12.4336 3.10156C12.681 2.85417 12.974 2.73047 13.3125 2.73047C13.6641 2.73047 13.957 2.85417 14.1914 3.10156C14.4388 3.34896 14.5625 3.64844 14.5625 4C14.5625 4.33854 14.4388 4.63151 14.1914 4.87891L12.5117 6.55859L14.1328 8.17969L15.8711 6.44141C16.1055 6.19401 16.3919 6.07031 16.7305 6.07031C17.082 6.07031 17.3815 6.19401 17.6289 6.44141C17.8763 6.6888 18 6.98828 18 7.33984C18 7.67839 17.8763 7.96484 17.6289 8.19922L15.8906 9.9375L17.0039 11.0312C17.1341 11.1615 17.1992 11.3242 17.1992 11.5195C17.1992 11.7018 17.1341 11.8581 17.0039 11.9883L14.4844 14.5078C14.1068 14.8724 13.6836 15.1523 13.2148 15.3477C12.7331 15.5299 12.2448 15.6211 11.75 15.6211C11.2682 15.6211 10.793 15.5299 10.3242 15.3477C9.85547 15.1523 9.43229 14.8724 9.05469 14.5078L8 13.4531L4.11328 17.3594C4.00911 17.4505 3.88542 17.4961 3.74219 17.4961C3.61198 17.4961 3.49479 17.4505 3.39062 17.3594C3.29948 17.2552 3.25391 17.138 3.25391 17.0078C3.25391 16.8646 3.29948 16.7409 3.39062 16.6367L7.29688 12.75L6.26172 11.7148C5.88411 11.3372 5.60417 10.9141 5.42188 10.4453C5.22656 9.96354 5.12891 9.48177 5.12891 9C5.12891 8.50521 5.22656 8.02344 5.42188 7.55469C5.60417 7.08594 5.88411 6.66276 6.26172 6.28516L8.78125 3.76562C8.91146 3.63542 9.06771 3.57031 9.25 3.57031C9.43229 3.57031 9.58854 3.63542 9.71875 3.76562L10.7539 4.78125ZM11.4766 5.48438L11.8281 5.83594L13.4883 4.17578C13.5404 4.1237 13.5664 4.0651 13.5664 4C13.5664 3.92188 13.5404 3.85677 13.4883 3.80469C13.4362 3.76562 13.3776 3.74609 13.3125 3.74609C13.2474 3.74609 13.1888 3.76562 13.1367 3.80469L11.4766 5.48438ZM6.96484 6.98828C6.41797 7.54818 6.14453 8.21875 6.14453 9C6.14453 9.78125 6.41797 10.4453 6.96484 10.9922L9.75781 13.7852C10.3177 14.3451 10.9883 14.625 11.7695 14.625C12.5508 14.625 13.2148 14.3451 13.7617 13.7852L16.0469 11.5L9.25 4.70312L6.96484 6.98828ZM14.8555 8.86328L15.207 9.21484L16.9258 7.49609C16.9779 7.44401 17.0039 7.38542 17.0039 7.32031C17.0039 7.25521 16.9779 7.19661 16.9258 7.14453C16.8737 7.09245 16.8151 7.06641 16.75 7.06641C16.6849 7.06641 16.6263 7.09245 16.5742 7.14453L14.8555 8.86328Z",
      fill: "currentColor"
    }
  )
);
const SvgArrowDropLeft4 = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var ArrowDropLeft4_default = SvgArrowDropLeft4;
